"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEarlyRequestCompleted = isEarlyRequestCompleted;
exports.cleanEarlyRequests = cleanEarlyRequests;
exports.isEditorUrl = exports.getIdFromCurrentUrl = exports.fetch = exports.buildUrl = exports.runIfParamDefined = void 0;

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _core = require("hub-http/middlewares/core");

var BASE_URL = "https://" + (0, _core.resolveApi)((0, _core.standardApi)('api', 'hubspot'));

var runIfParamDefined = function runIfParamDefined(func) {
  return function (param) {
    return param ? func(param) : null;
  };
};

exports.runIfParamDefined = runIfParamDefined;

var buildUrl = function buildUrl(path) {
  return BASE_URL + "/" + path + (path.indexOf('?') > -1 ? '&' : '?') + "portalId=" + _hubspot.default.get();
};

exports.buildUrl = buildUrl;

var fetch = function fetch(url, responseKey) {
  return window.earlyRequester.makeRequest(responseKey, {
    url: url,
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    },
    timeout: 15000
  });
};

exports.fetch = fetch;

var getIdFromCurrentUrl = function getIdFromCurrentUrl() {
  return (/\/([^\/]+)$/.exec(window.location.pathname) || [])[1];
};

exports.getIdFromCurrentUrl = getIdFromCurrentUrl;

var isEditorUrl = function isEditorUrl() {
  return /^\/lead-flows\/\d+\/edit\//.test(window.location.pathname);
};

exports.isEditorUrl = isEditorUrl;

function isEarlyRequestCompleted(key) {
  if (!window.earlyRequester) {
    return false;
  }

  var _ref = window.earlyRequester.getRequestStateByName(key) || {},
      _ref$finished = _ref.finished,
      isFinished = _ref$finished === void 0 ? false : _ref$finished;

  return isFinished;
}

function cleanEarlyRequests(requestName) {
  var requestsTracked = window.earlyRequester.requestsTracked;
  var cleanRequests = requestsTracked.filter(function (_ref2) {
    var name = _ref2.name;
    return name !== requestName;
  });
  window.earlyRequester.requestsTracked = cleanRequests;
}